<template>
  <div class="co-text-book">
    <Table :tableData='tableData' :tableHeadList='tableHeadList' :isBooks='true' @handleDelete='handleDelete' />
  </div>

</template>
<script>
import Table from "@/views/profile/components/mine/myCollection/common/Table";
import { getUserFavorite, delFavorite } from "@/network/resourceRequest/api";
import utils from "@/util/index";

export default {
  name: "CoTextbook",

  components: {
    Table
  },

  props: {
    //当前页面--------------------------------------------
    currentPage: {},
    //总页码--------------------------------------------
    pageTotal: {}
  },

  data() {
    return {
      tableData: [],
      //筛选条件--------------------------------------------
      fd: {
        resourceType: "textbook",
        pageNum: 1,
        pageSize: 8
      },

      //表格头部--------------------------------------------
      tableHeadList: [
        {
          prop: "name",
          label: "教材名称"
        },
        {
          prop: "course",
          label: "科目"
        },
        {
          prop: "phase",
          label: "学段"
        },
        {
          prop: "grade",
          label: "年级"
        },
        {
          prop: "edition",
          label: "版本"
        },
        {
          prop: "volume",
          label: "册别"
        }
      ]
    };
  },
  created() {
    this._getTableData();
  },

  watch: {
    currentPage(newPage) {
      this.$set(this.fd, "pageNum", newPage);
      this._getTableData();
    }
  },

  methods: {
    //获取表格数据--------------------------------------------
    _getTableData() {
      getUserFavorite(this.fd).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list;
          this.$emit("update:pageTotal", res.data.data.total);
        } else {
          console.log("CoTextbook", res.data.code);
        }
      });
    },

    //取消收藏
    handleDelete(scope) {
      delFavorite(scope.row.id).then(res => {
        if (res.data.success) {
          utils.tips("success", res.data.code);
          //更新
          this._getTableData();
        } else {
          console.log("CoTextbook", res.data.code);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
</style>